var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickCollectSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 104,
    viewBox: "0 0 110 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5089_404)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.8737 0H17.9338C13.5156 0 9.93384 3.58172 9.93384 8V27.9399C9.93384 32.3582 13.5156 35.9399 17.9338 35.9399H37.8737C42.292 35.9399 45.8737 32.3582 45.8737 27.9399V8C45.8737 3.58172 42.292 0 37.8737 0Z",
    fill: "#00A657",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.862 22.9197H93.3901C91.1809 22.9197 89.3901 24.7105 89.3901 26.9197V39.3915C89.3901 41.6006 91.1809 43.3915 93.3901 43.3915H105.862C108.071 43.3915 109.862 41.6006 109.862 39.3915V26.9197C109.862 24.7105 108.071 22.9197 105.862 22.9197Z",
    fill: "#00A657",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.1253 52.2051H4.13794C1.9288 52.2051 0.137939 53.9959 0.137939 56.2051V70.1925C0.137939 72.4016 1.9288 74.1925 4.13794 74.1925H18.1253C20.3345 74.1925 22.1253 72.4016 22.1253 70.1925V56.2051C22.1253 53.9959 20.3345 52.2051 18.1253 52.2051Z",
    fill: "#E6FFF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.345 74.485H83.8289C81.6198 74.485 79.8289 76.2758 79.8289 78.485V96.0011C79.8289 98.2102 81.6198 100.001 83.8289 100.001H101.345C103.554 100.001 105.345 98.2102 105.345 96.0011V78.485C105.345 76.2758 103.554 74.485 101.345 74.485Z",
    fill: "#E6FFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3451 96.4873C81.4511 96.4873 100.182 77.7562 100.182 54.6502C100.182 31.5442 81.4511 12.8131 58.3451 12.8131C35.2391 12.8131 16.508 31.5442 16.508 54.6502C16.508 77.7562 35.2391 96.4873 58.3451 96.4873Z",
    fill: "#00A657"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5089_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5049 56.9141L51.556 65.9652L74.1838 43.3374",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5089_404",
    x: 8.50488,
    y: 13.3374,
    width: 99.6789,
    height: 90.6278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.227451 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5089_404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5089_404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5089_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickCollectSuccess);
export default __webpack_public_path__ + "static/media/quick-collect-success.18ccb17493806dd3be1bf1505fe640aa.svg";
export { ForwardRef as ReactComponent };